module.exports = __webpack_public_path__ + "static/img/historyImage.083735ac.svg";